import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import * as fromComponents from './components';
import { ImgFallbackDirective } from './directives/img-fallback.directive';
import { POSContentComponent } from './components/pos-content/pos-content.component';

@NgModule({
  declarations: [...fromComponents.components, ImgFallbackDirective],
  exports: [RouterModule, ...fromComponents.components, ImgFallbackDirective, POSContentComponent],
  imports: [CommonModule, RouterModule, fromComponents.PrivacyNoticeComponent],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class SharedModule {}
